import { useMemo } from "react";
import { useTableOfContents } from "../../hooks/tableOfContentsHooks/useTableOfContents";
import styles from "./RelatedTopics.module.scss";
import { useNavigate } from "react-router-dom";
import { isNullOrEmpty } from "../../utils/isNullOrEmpty";
import { useDispatch } from "react-redux";
import { resetState } from "../counter/counterSlice";
import { isSameItem } from "../../hooks/tableOfContentsHooks/tableOfContents";

const RelatedTopics = () => {
  const { umbrellaNode, tableOfContents } = useTableOfContents();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getItemId = (item) => {
    return (
      item?.id ??
      item?.href ??
      new URLSearchParams(item?.msPath?.split("?")[1] || "").get("sectionId")
    );
  };

  const handleClickAction = (item) => {
    dispatch(resetState());
    navigate(item.msPath);
  };

  const excludeCurrentTopic = useMemo(() => {
    const children = umbrellaNode?.children || [];

    if (children.length === 0) return [];

    if (isNullOrEmpty(tableOfContents)) return children;

    return children.filter((item) => !isSameItem(item, tableOfContents)).slice(0, 6);
  }, [umbrellaNode, tableOfContents]);

  return (
    !isNullOrEmpty(umbrellaNode) && (
      <div className={styles.relatedTopicsContainer}>
        <div className={styles.title}>Related topics</div>
        <ul>
          {excludeCurrentTopic.map((item) => (
            <li key={getItemId(item)}>
              <span onClick={() => handleClickAction(item)} role="button">
                {item.title}
              </span>
            </li>
          ))}
        </ul>
      </div>
    )
  );
};
export default RelatedTopics;
